import { HttpService } from "../index";

export class CalculationService {

    constructor(
        protected httpService: HttpService
    ) {}

    getOverviewCalculation(year:number) {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.get('/api/v1/overview/' + year)
                .then((response) => {
                    resolve(response.json());
                }).catch((error) => {
                    reject(error);
                });
        });        
    }

    getCalculation(id:string, params:any = undefined) {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.get('/api/v1/calculations/' + id, params)
                .then((response) => {
                    resolve(response.json());
                }).catch((error) => {
                    reject(error);
                });
        });
    }

    editRow(row:any) {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.put('/api/v1/rows/' + row.id, row)
                .then((response) => {
                    resolve(response.json());
                }).catch((error) => {
                    reject(error);
                });
        });
    }

    addRow(referenceId:number, type:string, position:string) {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.post('/api/v1/rows', {
                type        : type ,
                referenceId : referenceId ,
                position    : position
            }).then((response) => {
                resolve(response.json());
            }).catch((error) => {
                reject(error);
            });
        });
    }

    removeRow(row:any) {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.delete('/api/v1/rows/' + row.id)
                .then((response) => {
                    resolve(response.json());
                }).catch((error) => {
                    reject(error);
                });
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/calculation/calculation-service.ts